import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft, Camera, Upload, Share2, Wand2, Sparkles } from 'lucide-react';
import { Card } from '../components/Card';
interface RolePlayModuleProps {
  onBack: () => void;
}
export function RolePlayModule({
  onBack
}: RolePlayModuleProps) {
  const [selectedDynasty, setSelectedDynasty] = useState<'tang' | 'song'>('tang');
  const [isGenerating, setIsGenerating] = useState(false);
  const [generatedImage, setGeneratedImage] = useState<string | null>(null);
  const handleGenerate = () => {
    setIsGenerating(true);
    setTimeout(() => {
      setIsGenerating(false);
      setGeneratedImage(selectedDynasty === 'tang' ? 'https://images.unsplash.com/photo-1531123414780-f74242c2b052?q=80&w=1000&auto=format&fit=crop' : 'https://images.unsplash.com/photo-1523585895729-799477eb7097?q=80&w=1000&auto=format&fit=crop');
    }, 2000);
  };
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} className="min-h-screen w-full p-4 flex flex-col bg-[#F8FAFC]" data-id="element-750">
      {/* Header */}
      <div className="flex items-center justify-between mb-8 max-w-6xl mx-auto w-full" data-id="element-751">
        <button onClick={onBack} className="flex items-center space-x-2 text-slate-600 hover:text-slate-900 bg-white px-4 py-2 rounded-full shadow-sm border border-slate-100" data-id="element-752">
          <ArrowLeft size={20} data-id="element-753" />
          <span className="font-bold text-sm" data-id="element-754">返回</span>
        </button>
        <h1 className="text-2xl font-bold font-display text-slate-900" data-id="element-755">
          一照入画 · 小小词人
        </h1>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-6xl mx-auto w-full flex-1 pb-8" data-id="element-756">
        {/* Input Section */}
        <div className="space-y-6" data-id="element-757">
          <Card className="p-6" data-id="element-758">
            <h3 className="text-lg font-bold text-slate-900 mb-4 flex items-center" data-id="element-759">
              <span className="w-6 h-6 rounded-full bg-teal-100 text-teal-600 flex items-center justify-center text-xs mr-2" data-id="element-760">
                1
              </span>
              选择朝代
            </h3>
            <div className="grid grid-cols-2 gap-4" data-id="element-761">
              <button onClick={() => setSelectedDynasty('tang')} className={`flex flex-col items-center p-4 rounded-xl border-2 transition-all ${selectedDynasty === 'tang' ? 'border-[#FF6B6B] bg-red-50' : 'border-slate-100 hover:border-slate-200'}`} data-id="element-762">
                <div className="w-20 h-20 rounded-full bg-gradient-to-br from-[#FF6B6B] to-[#FF8E53] mb-3 flex items-center justify-center text-white font-bold text-2xl shadow-lg" data-id="element-763">
                  唐
                </div>
                <span className={`font-bold ${selectedDynasty === 'tang' ? 'text-[#FF6B6B]' : 'text-slate-600'}`} data-id="element-764">
                  大唐盛世
                </span>
              </button>

              <button onClick={() => setSelectedDynasty('song')} className={`flex flex-col items-center p-4 rounded-xl border-2 transition-all ${selectedDynasty === 'song' ? 'border-teal-500 bg-teal-50' : 'border-slate-100 hover:border-slate-200'}`} data-id="element-765">
                <div className="w-20 h-20 rounded-full bg-gradient-to-br from-teal-400 to-teal-500 mb-3 flex items-center justify-center text-white font-bold text-2xl shadow-lg" data-id="element-766">
                  宋
                </div>
                <span className={`font-bold ${selectedDynasty === 'song' ? 'text-teal-600' : 'text-slate-600'}`} data-id="element-767">
                  风雅大宋
                </span>
              </button>
            </div>
          </Card>

          <Card className="p-6" data-id="element-768">
            <h3 className="text-lg font-bold text-slate-900 mb-4 flex items-center" data-id="element-769">
              <span className="w-6 h-6 rounded-full bg-teal-100 text-teal-600 flex items-center justify-center text-xs mr-2" data-id="element-770">
                2
              </span>
              上传照片
            </h3>
            <div className="border-2 border-dashed border-slate-200 rounded-xl p-8 flex flex-col items-center justify-center text-slate-400 hover:bg-slate-50 hover:border-slate-300 cursor-pointer transition-colors h-48 bg-slate-50/50" data-id="element-771">
              <div className="w-16 h-16 bg-white rounded-full shadow-sm flex items-center justify-center mb-4" data-id="element-772">
                <Camera size={32} className="text-slate-400" data-id="element-773" />
              </div>
              <p className="text-sm font-medium" data-id="element-774">点击拍摄或上传照片</p>
            </div>
          </Card>

          <button onClick={handleGenerate} disabled={isGenerating} className="w-full bg-gradient-to-r from-[#FF6B6B] to-[#FF8E53] text-white py-4 rounded-xl font-bold text-lg shadow-lg shadow-orange-200 hover:shadow-xl hover:scale-[1.02] transition-all flex items-center justify-center space-x-2 disabled:opacity-70 disabled:hover:scale-100" data-id="element-775">
            {isGenerating ? <>
                <Sparkles className="animate-spin" data-id="element-776" />
                <span data-id="element-777">AI正在施展魔法...</span>
              </> : <>
                <Wand2 data-id="element-778" />
                <span data-id="element-779">生成古风造型</span>
              </>}
          </button>
        </div>

        {/* Result Section */}
        <div className="h-full" data-id="element-780">
          <Card className="h-full min-h-[500px] flex flex-col items-center justify-center bg-slate-50 border-dashed border-2 border-slate-200" data-id="element-781">
            {generatedImage ? <div className="relative w-full h-full flex flex-col items-center p-4" data-id="element-782">
                <motion.div initial={{
              opacity: 0,
              scale: 0.9
            }} animate={{
              opacity: 1,
              scale: 1
            }} className="relative w-full max-w-sm aspect-[3/4] rounded-2xl overflow-hidden shadow-2xl" data-id="element-783">
                  <img src={generatedImage} alt="Generated" className="w-full h-full object-cover" data-id="element-784" />

                  {/* Overlay Text */}
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-8 text-white" data-id="element-785">
                    <p className="font-display text-2xl font-bold mb-1" data-id="element-786">
                      小小词人
                    </p>
                    <p className="text-sm opacity-80 font-medium" data-id="element-787">
                      AI专属定制 · 独一无二
                    </p>
                  </div>
                </motion.div>

                <div className="flex space-x-4 mt-8" data-id="element-788">
                  <button className="flex items-center space-x-2 bg-white text-slate-900 px-6 py-3 rounded-full font-bold shadow-lg hover:bg-slate-50 transition-colors" data-id="element-789">
                    <Share2 size={20} data-id="element-790" />
                    <span data-id="element-791">分享</span>
                  </button>
                  <button className="flex items-center space-x-2 bg-slate-900 text-white px-6 py-3 rounded-full font-bold shadow-lg hover:bg-slate-800 transition-colors" data-id="element-792">
                    <Upload size={20} data-id="element-793" />
                    <span data-id="element-794">保存</span>
                  </button>
                </div>
              </div> : <div className="text-center text-slate-400" data-id="element-795">
                <div className="w-24 h-24 bg-white rounded-full mx-auto mb-4 flex items-center justify-center shadow-sm" data-id="element-796">
                  <Wand2 size={40} className="text-slate-300" data-id="element-797" />
                </div>
                <p className="font-medium" data-id="element-798">魔法画卷准备中...</p>
              </div>}
          </Card>
        </div>
      </div>
    </motion.div>;
}